import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { AppCacheService } from '../../core/services/cache/app-cache.service';
import { CmsService } from '../../core/services/cms.service';
import { CmsContent, CmsContentField } from '../../shared/models/cms';
import { CacheConstant, CMSPages, CMSTemplateNames, UserDeviceConstant } from '../../../app/core/constants/app.constant';
import { StaticPageContent, ContentStructureDetails } from '../../shared/models/cms';
import * as _ from 'lodash';
import { DomSanitizer } from '@angular/platform-browser';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BaseComponent } from '../../../app/app.base.component';
import { AppConfigService } from '../../../app/core/services/init/app-config.service';
import { AmazonVideoComponent } from './amazon_video/amazon_video.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'par-amazon',
  templateUrl: './amazon.component.html',
  styleUrls: ['./amazon.component.scss']
})
export class MajorAmazonComponent extends BaseComponent implements OnInit {
  envProperties = this.cache.get(CacheConstant.Env_Properties);
  isAuthenticated: boolean = false;
  cmsPageName: CMSPages;
  templateNum: any;
  buId = this.envProperties.buId;
  websiteName = this.envProperties.theme;
  callToActionMajor: any[] = [];
  staticTitleContent: any;
  amazonImage: string;
  staticVideoContent: any;
content: any;
  constructor(
    private cache: AppCacheService,
    private cmsService: CmsService,
    deviceDetectorService: DeviceDetectorService,
    private appConfig: AppConfigService,
    private dialog: MatDialog

  ) {
    super(deviceDetectorService, cache, appConfig);

   }
  ngOnInit() {
    this.getAmazonPageData();
  }

  getAmazonPageData() {
    if (this.isMobileDevice() && this.websiteName == 'Major') {
        this.cmsPageName = this.isAuthenticated ? CMSPages.Mobile_Home : CMSPages.Mobile_Login;
    }
     else
    this.cmsPageName = this.isAuthenticated ? CMSPages.Home : CMSPages.Login;
    this.templateNum = this.envProperties.cmsPageConfigVO.staticPageTemplateId;
    let pageSeqNumber = this.isAuthenticated ? this.envProperties.cmsPageConfigVO.amazon : this.envProperties.cmsPageConfigVO.amazon;
    this.cmsService.getCmsStaticPageTemplateByPageNameAndTemplateNum(this.cmsPageName, this.buId, this.templateNum, pageSeqNumber).subscribe((response: any) => {
    if (!response.hasError && response.length > 0) {
        this.content = response
          this.content.forEach((cta: CmsContent) => {
        cta.contentStructure = JSON.parse(cta.contentStructure);
     
      });
        this.content.sort((a, b) => b.contentNum - a.contentNum);
        this.content.forEach((cta: any, i) => {
          if (cta.contentName == CMSTemplateNames.Web_AmazonPage +" 1"  || cta.contentName == CMSTemplateNames.Mobile_AmazonPage +" 1" )
             {
            this.staticTitleContent = cta.contentStructure.recordList;
          } else if (cta.contentName == CMSTemplateNames.Web_AmazonPage+ " 2" || cta.contentName == CMSTemplateNames.Mobile_AmazonPage +" 2") {
            this.staticVideoContent= cta.contentStructure.recordList;
          }
          else if (cta.contentName == CMSTemplateNames.Web_AmazonPage+ " 3" || cta.contentName == CMSTemplateNames.Mobile_AmazonPage +" 3")
             { this.callToActionMajor = cta.contentStructure.recordList; }
        });

      }    
    });

  }
  openAlertDialog(videoURL:any) {
    if(this.isMobileDevice()){
      const dialogRef = this.dialog.open(AmazonVideoComponent,{
        data:{
        URL:videoURL,
        device:'Mobile'
        },
      });
    }
    else{
      const dialogRef = this.dialog.open(AmazonVideoComponent,{
        data:{
        URL:videoURL,
        device:'Desktop'
        },
      });
    }
    
  }
  navigateToTargetLink(cmsContentLinkObj: any) {
    if (!_.isEmpty(cmsContentLinkObj)) {
      this.cmsService.redirectBasedOnLinkType(cmsContentLinkObj);
    }
  }
}


